import { shallowMount } from "@vue/test-utils";
import NoCliente from "@/views/NoCliente";

describe("NoCliente component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(NoCliente);
  });

  it("Renders del component NoCliente", () => {
    expect(wrapper).toBeDefined();
  });
});
